__turbopack_context__.v({
  "CatProduct": "_88cxuq_CatProduct",
  "LinkItemMobile": "_88cxuq_LinkItemMobile",
  "active": "_88cxuq_active",
  "bar": "_88cxuq_bar",
  "bgHeader": "_88cxuq_bgHeader",
  "blue": "_88cxuq_blue",
  "blueLight": "_88cxuq_blueLight",
  "btn": "_88cxuq_btn",
  "btnAssinar": "_88cxuq_btnAssinar",
  "containerBtn": "_88cxuq_containerBtn",
  "dflex": "_88cxuq_dflex",
  "hamburger": "_88cxuq_hamburger",
  "hasSubmenu": "_88cxuq_hasSubmenu",
  "menuOpen": "_88cxuq_menuOpen",
  "navMenu": "_88cxuq_navMenu",
  "open": "_88cxuq_open",
  "produtoAssinar": "_88cxuq_produtoAssinar",
  "purple": "_88cxuq_purple",
  "submenu": "_88cxuq_submenu",
  "submenuButton": "_88cxuq_submenuButton",
  "titleProduct": "_88cxuq_titleProduct",
  "yellow": "_88cxuq_yellow",
});
